import { LyfeTooltip } from "@lyfegen-platform/react-common";
import { Tab, Tabs, TooltipProps } from "@material-ui/core";
import { ReactChild } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router";
import { useRecoilState } from "recoil";
import { useMapThemeClasses } from "../../hooks/use-map-theme-styles";

interface ITabComponentProps {
	onTabClick?: (v: number) => void;
	setTabInUrl: (v: number) => void;
	tabState: any;
	tabLabels: Array<string>;
	areTabsDisabled: Array<boolean>;
	tooltip?: Array<string | JSX.Element | undefined>;
	tooltipProps?: Array<TooltipProps | undefined>;
	TabIcon?: Array<JSX.Element | undefined>;
	propStyles?: Array<any>;
}

const TabComponent: React.FC<ITabComponentProps> = ({
	onTabClick,
	setTabInUrl,
	tabState,
	tabLabels,
	areTabsDisabled,
	tooltip,
	TabIcon,
	propStyles = [],
}) => {
	const { tabIndicator, tabRoot, tabTitle, tabActiveTitle, tabInactive } = useMapThemeClasses();
	const { t } = useTranslation();
	const { push } = useHistory();
	const [activeTab, setActiveTab] = useRecoilState(tabState);

	function handleTabChange(event: React.ChangeEvent<Record<string, unknown>>, newTabValue: number) {
		if (newTabValue == activeTab) {
			return;
		}

		event.preventDefault();
		push(`${window.location.pathname}${setTabInUrl(newTabValue)}`);
		setActiveTab(newTabValue);
		onTabClick && onTabClick(newTabValue);
	}

	function a11yProps(index: number) {
		return {
			id: `simple-tab-${index}`,
			"aria-controls": `simple-tabpanel-${index}`,
		};
	}

	function getLabel(index: number) {
		if (areTabsDisabled[index] && tooltip?.[index]) {
			return typeof tooltip[index] === "string" ? (
				<LyfeTooltip
					placement="right-start"
					title={typeof tooltip[index] === "string" ? t((tooltip[index] as string) || "") : (tooltip[index] as ReactChild)}
				>
					<span>{typeof tabLabels[index] === "string" ? t(tabLabels[index]) : tabLabels[index]}</span>
				</LyfeTooltip>
			) : (
				tooltip[index]
			);
		}

		return typeof tabLabels[index] === "string" ? t(tabLabels[index]) : tabLabels[index];
	}

	return (
		<Tabs
			className={tabRoot}
			TabIndicatorProps={{
				className: tabIndicator,
			}}
			value={activeTab}
			scrollButtons="off"
			onChange={handleTabChange}
			aria-label="data-tabs"
			classes={{ root: tabTitle }}
		>
			{tabLabels.map((_, i) => (
				<Tab
					style={{ pointerEvents: "auto", ...propStyles[i] }}
					key={i}
					label={getLabel(i)}
					icon={TabIcon && TabIcon[i]}
					disabled={!!areTabsDisabled[i]}
					className={activeTab === i ? tabActiveTitle : tabInactive}
					{...a11yProps(i)}
				/>
			))}
		</Tabs>
	);
};

export default TabComponent;
